import withUserKindDisabledChoices from './withUserKindDisabledChoices';
import withUserKindValidationModal from './withUserKindValidationModal';
import withConcatenateParams from './withConcatenateParams';
import withAuthorType from './withAuthorType';
import withMultiplyByHundred from './withMultiplyByHundred';
import withModifiedLabel from './withModifiedLabel';
import withLimitedList from './withLimitedList';
import withTranslation from './withTranslation';
import withCatLengthValidation from './withCatLengthValidation';
import withSort from './withSort';
import withSuperAdminPermission from './withSuperAdminPermission';
import withDisabledCandidacyStatus from './withDisabledCandidacyStatus';
import withDisabledByDate from './withDisabledByDate';
import withManualClientChoice from './withManualClientChoice';
import withManualExpertChoice from './withManualExpertChoice';
import withGenerateCategoryGuid from './withGenerateCategoryGuid';
import withChoicesFromRecord from './withChoicesFromRecord';
import withContractSignatureMode from './withContractSignatureMode';

const extensions = {
  authorType: withAuthorType,
  disabledChoices: withUserKindDisabledChoices,
  limitedList: withLimitedList,
  concatenateParams: withConcatenateParams,
  modal: withUserKindValidationModal,
  modifiedLabel: withModifiedLabel,
  multiplyByHundredInput: withMultiplyByHundred,
  translation: withTranslation,
  sort: withSort,
  catLengthValidation: withCatLengthValidation,
  superAdminPermission: withSuperAdminPermission,
  disabledCandidacyStatus: withDisabledCandidacyStatus,
  disabledByDate: withDisabledByDate,
  manualClientChoice: withManualClientChoice,
  manualExpertChoice: withManualExpertChoice,
  generateCategoryGuid: withGenerateCategoryGuid,
  choicesFromRecord: withChoicesFromRecord,
  contractSignatureMode: withContractSignatureMode,
};

export default extensions;
